import React, { Suspense, lazy } from 'react';
import Loading from '../LoadingComponent';

const ApprovePoints = lazy(() =>
  import(/* webpackChunkName: "ApprovePoints" */ '../../components/rewards/ApprovePoints')
);

export default function AsyncApprovePoints({...props}) {
  return (
    <Suspense fallback={<Loading />}>
      <ApprovePoints {...props} />
    </Suspense>
  );
}
